export default {
  'profile.verified': 'ได้รับการยืนยันแล้ว',
  'profile.unverified': 'ยังไม่ได้รับการยืนยัน',
  'profile.refresh': 'รีเฟรช',
  'profile.name': 'ชื่อ',
  'profile.getCode': 'รับรหัสยืนยัน',
  'profile.codeTip': 'กรุณาใส่รหัสยืนยัน',
  'profile.verifyCode': 'รหัสยืนยัน',
  'profile.phoneChange': 'เปลี่ยนหมายเลขโทรศัพท์',
  'profile.checkPhone': 'ตรวจสอบโทรศัพท์ปัจจุบัน',
  'profile.bindNewPhone': 'ผูกหมายเลขโทรศัพท์ใหม่',
  'profile.nuxt': 'ขั้นตอนถัดไป',
  'profile.changeSuccess': 'เปลี่ยนแปลงสำเร็จ!',
  'profile.firstNameTip': 'กรุณาใส่ชื่อ',
  'profile.lastNameTip': 'กรุณาใส่นามสกุล',
  'profile.emailChange': 'เปลี่ยนอีเมล',
  'profile.checkEmail': 'ตรวจสอบอีเมลปัจจุบัน',
  'profile.bindNewEmail': 'ผูกอีเมลใหม่',
  'profile.bindEmailTip': 'กรุณาใส่อีเมลใหม่',
  'app.profile': 'ศูนย์ส่วนบุคคล',
  'app.profile.account': 'ข้อมูลบัญชี',
  'app.profile.account.save': 'บันทึก',
  'app.profile.account.account': 'บัญชีผู้ใช้',
  'app.profile.account.password': 'รหัสผ่าน',
  'app.profile.account.password.update': 'อัปเดตรหัสผ่านครั้งล่าสุดเมื่อ',
  'app.profile.account.password.reset': 'รีเซ็ตรหัสผ่าน',
  'app.profile.account.name.first': 'ชื่อจริง',
  'app.profile.account.name.last': 'นามสกุล',
  'app.profile.account.name.phone': 'โทรศัพท์มือถือ',
  'app.profile.account.name.phone.tip':
    'เราอาจใช้หมายเลขโทรศัพท์นี้เพื่อส่งข้อความเกี่ยวกับเหตุการณ์ทางความปลอดภัย ใบแจ้งหนี้และการแจ้งเตือนธุรกิจ',
  'app.profile.account.name.url': 'ที่อยู่คืนการเรียกกลับ',
  'app.profile.account.name.urlTip':
    'ต้องขึ้นต้นด้วย http:// หรือ https:// ไม่รองรับพอร์ตแบบกำหนดเอง และไม่รองรับกลุ่มเครือข่ายส่วนตัวที่มีที่อยู่ IP 10.0.0.0/8, 172.16.0.0/12 และ 192.168.0.0/16',
  'app.profile.account.name.verification': 'การตรวจสอบ',
  'app.profile.account.name.verification.tip[1]': 'ผ่าน',
  'app.profile.account.name.verification.tip[2]': 'ไม่ผ่าน',
  'app.profile.developer': 'ข้อมูลนักพัฒนา',
  'app.profile.developer.remark': 'จำกัดการเรียกใช้ API',
  'app.profile.developer.label[1]': 'Developer ID (DevKey)',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': 'ดูและคัดลอก',
  'app.profile.developer.reset': 'รีเซ็ต',
  'app.profile.developer.reset.tip': 'เคล็ดลับ',
  'app.profile.developer.reset.tip.content':
    'การเปลี่ยนแปลง Dev Secret จะมีผลต่อการพุช API โดยต้องให้ผู้เรียกเปลี่ยนรหัสการเรียกใช้',
  'app.profile.developer.reset.tip.sure': 'ยืนยัน',
  'app.profile.developer.reset.tip.cancel': 'หลังจากนี้',
  'app.profile.developer.copy.success': 'คัดลอกสำเร็จ',
  'app.profile.developer.reset.success': 'รีเซ็ตสำเร็จ',
  'app.profile.single': 'เข้าสู่ระบบเดียว',
  'app.profile.single.tip[1]': 'ปรับปรุงความปลอดภัยและลดความเสี่ยงของบัญชี',
  'app.profile.single.tip[2]':
    'หลีกเลี่ยงการสร้างบัญชีบ่อยครั้งเมื่อพนักงานใช้ระบบธุรกิจที่แตกต่างกัน',
  'app.profile.single.tip[3]': 'จัดเรียงการตรวจสอบโดยใช้ระบบบัญชีพนักงานภายใน',
  'app.profile.single.enable': 'ติดต่อธุรกิจ',
  'app.profile.single.title': 'คำขอธุรกิจ',
  'app.profile.single.subject': 'เรื่อง',
  'app.profile.single.subject.value': 'เปิดใช้งาน Single Sign-On สำหรับบัญชีของฉัน',
  'app.profile.single.content':
    'สวัสดี ฉันต้องการเปิดใช้งาน Single Sign-On (SSO) กรุณาช่วยแนะนำด้วย ขอบคุณครับ/ค่ะ',
  'app.profile.single.subject.validator': 'โปรดป้อนเรื่องของคุณ',
  'app.profile.single.subject.doc': 'เปิดใช้งานการเข้าสู่ระบบเดียวสำหรับบัญชีของฉัน',
  'app.profile.single.message': 'ข้อความ',
  'app.profile.single.message.validator': 'โปรดป้อนข้อความของคุณ',
  'app.profile.single.submit': 'ส่งคำขอ',
  'app.profile.single.submit.success': `ส่งเรียบร้อยแล้ว โปรดรอการตอบกลับทางอีเมลจากผู้ดูแลระบบ`,
  'app.profile.account.deletion': 'การลบบัญชี',
  'app.profile.account.deletion.warn':
    'เมื่อคุณลบบัญชีของคุณแล้ว บัญชีของคุณพร้อมกับข้อมูลผู้ใช้ของคุณ ข้อมูลธุรกิจ ข้อมูลการสั่งซื้อและข้อมูลอื่น ๆ ที่เกี่ยวข้องจะถูกลบอย่างถาวร หลังจากลบบัญชีของคุณแล้ว คุณจะไม่สามารถกู้คืนบัญชีหรือข้อมูลของคุณได้อีกต่อไป',
  'app.profile.account.deletion.action': 'ลบบัญชีของฉัน',
  'app.profile.delete.title': 'ลบบัญชี',
  'app.profile.delete.content':
    'คำเตือน! การลบบัญชีของคุณเป็นสิ่งที่ไม่สามารถย้อนกลับได้ มันจะลบข้อมูลและข้อมูลอื่น ๆ เช่นผู้ใช้ ธุรกิจ ยอดคงเหลือ บิล รายการสั่งซื้อและความสนใจของบัญชีนี้อย่างถาวรและบริการที่เกี่ยวข้องทั้งหมดจะถูกยกเลิก',
  'app.profile.delete.content2':
    'คุณอาจบรรลุเป้าหมายได้โดยการแก้ไขที่อยู่อีเมลบัญชี หรือมอบสิทธิ์บทบาทให้สมาชิกองค์กร แนะนำให้เก็บบัญชีไว้ใช้งาน หากไม่มีความจำเป็นต้องลบ',
  'app.profile.delete.warn': 'เมื่อยังมีเงินเพิ่มเติมที่จะชำระ บัญชีของคุณไม่สามารถลบได้!',
  'app.profile.delete.cancel': 'ยกเลิก',
  'app.profile.delete.next': 'ต่อไป',
  'app.profile.delete.delete': 'ลบ',
  'app.profile.delete.confirm': 'ยืนยันการลบ',
  'app.profile.delete.confirm.content':
    'ก่อนที่การลบบัญชีของคุณจะมีผล เราจะตรวจสอบบัญชีของคุณดังนี้ โปรดค้นหารหัสยืนยันในอีเมล',
  'app.profile.delete.confirm.send': 'ส่งรหัสยืนยัน',
  'app.profile.delete.confirm.send.resend': 'ส่งรหัสยืนยันอีกครั้ง',
  'app.profile.delete.confirm.resend': 'ส่งอีกครั้ง',
  'app.profile.delete.confirm.rule': 'โปรดป้อนรหัสยืนยันที่ถูกต้อง',
  'app.profile.delete.confirm.code.title': 'รหัสยืนยันทางอีเมล',
  'app.profile.delete.confirm.code.desc':
    'เพื่อยืนยันตัวตนและความปลอดภัยของบัญชี กรุณาใส่รหัสยืนยันที่ได้รับทางอีเมล currentAccount.email',
  'app.profile.delete.confirm.reason.title': 'เหตุผลในการลบ',
  'app.profile.delete.confirm.reason.desc': 'ข้อมูลเหล่านี้ช่วยให้เราปรับปรุงผลิตภัณฑ์ได้ดีขึ้น',
  'app.profile.delete.confirm.reason.placeholder': 'เลือกเหตุผล',
  'app.profile.delete.confirm.reason.select1': 'ลบบัญชีทดสอบ',
  'app.profile.delete.confirm.reason.select2': 'เปลี่ยนไปใช้บัญชีอื่น',
  'app.profile.delete.confirm.reason.select3': 'ไม่มีความสนใจในการใช้บริการ EngageLab อีกต่อไป',
  'app.profile.delete.confirm.reason.select4': 'อื่นๆ',
  'app.profile.reset.title': 'รีเซ็ตรหัสผ่าน',
  'app.profile.reset.password.old': 'รหัสผ่านเก่า',
  'app.profile.reset.password.old.placeholder': 'โปรดป้อนรหัสผ่านเก่า',
  'app.profile.reset.password.new': 'รหัสผ่านใหม่',
  'app.profile.reset.password.new.placeholder': 'โปรดป้อนรหัสผ่านใหม่',
  'app.profile.reset.password.confirm': 'ยืนยันรหัสผ่าน',
  'app.profile.reset.password.confirm.placeholder': 'โปรดยืนยันรหัสผ่านของคุณ',
  'app.profile.reset.cancel': 'ยกเลิก',
  'app.profile.reset.confirm': 'ยืนยัน',
  'app.profile.rule.blank': 'ไม่สามารถเว้นว่างได้',
  'app.profile.reset.new.rule[0]': 'มีอักขระอย่างน้อย 8 ตัว',
  'app.profile.reset.new.rule[1]': 'ควรมีตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กในเวลาเดียวกัน',
  'app.profile.reset.new.rule[2]': 'มีตัวเลข (0-9) หรือสัญลักษณ์อย่างน้อย 1 ตัว',
  'app.profile.reset.confrim.rule[0]': 'รหัสผ่านไม่ตรงกัน',
  'app.profile.reset.old.rule[0]': 'รหัสผ่านไม่ตรงกัน',
  'app.profile.reset.success': 'รหัสผ่านของคุณถูกรีเซ็ตแล้ว',
  'app.profile.aws.title': 'การสั่งซื้อของ Amazon',
  'app.profile.aws.subtitle':
    'บัญชี EngageLab ของคุณได้เชื่อมโยงกับบัญชี Amazon แล้ว คุณสามารถเชื่อมโยงการสั่งซื้อของ Amazon กับบริการที่เกี่ยวข้องของ EngageLab เพื่อรับสิทธิประโยชน์ VIP ได้ที่นี่',
  'app.profile.aws.account': 'รหัสบัญชี Amazon:',
  'app.profile.aws.btn': 'จัดการการสั่งซื้อ',
  'app.profile.human.code.loadingTip': 'โปรดรอสักครู่...',
  'app.profile.human.code.placeholder': 'โปรดใส่รหัสยืนยัน',
  'app.profile.human.check.tip': 'โปรดตรวจสอบความเป็นมนุษย์ก่อน',
  'app.profile.human.check.error': 'การตรวจสอบความเป็นมนุษย์ล้มเหลว โปรดลองใหม่อีกครั้ง',
  'app.profile.sso.title': 'บริการกำหนดค่า SSO',
  'app.profile.sso.empty.title': 'คุณยังไม่ได้กำหนดค่า SSO ใดๆ',
  'app.profile.sso.empty.description':
    'หลังจากกำหนดค่า SSO แล้ว ผู้ใช้ สมาชิก และพันธมิตรทางธุรกิจภายใต้องค์กรที่กำหนดค่าสามารถเข้าถึงทุกอย่างที่พวกเขาต้องการเพื่อทำงานที่ดีที่สุดได้อย่างปลอดภัย รวมถึงประสบการณ์การเข้าสู่ระบบที่ใช้งานง่าย',
  'app.profile.sso.empty.configure': 'กำหนดค่า SSO',
  'app.profile.sso.empty.title2': 'ไม่มีสิทธิประโยชน์ SSO',
  'app.profile.sso.empty.description2':
    'องค์กรของคุณยังไม่ได้เปิดใช้งานสิทธิประโยชน์ SSO โปรดติดต่อธุรกิจเพื่อเปิดใช้งานสิทธิประโยชน์ก่อนที่จะกำหนดค่า',
  'app.profile.sso.empty.contact': 'ติดต่อเรา',
  'app.profile.sso.empty.contact.content': 'ฉันต้องการกำหนดค่า SSO',
  'app.profile.sso.list.configure': 'กำหนดค่า SSO',
  'app.profile.sso.list.authorizedOrg': 'องค์กรที่ได้รับอนุญาต',
  'app.profile.sso.list.benefitStatus': 'สถานะสิทธิประโยชน์',
  'app.profile.sso.list.authorizedOrgLong':
    'องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต องค์กรที่ได้รับอนุญาต',
  'app.profile.sso.list.edit': 'แก้ไข',
  'app.profile.sso.list.authorize': 'อนุญาต',
  'app.profile.sso.list.delete': 'ลบ',
  'app.profile.sso.list.deleteConfirm.title': 'ยืนยันการลบบริการ SSO {name}?',
  'app.profile.sso.list.deleteConfirm.content':
    'หลังจากลบบริการ SSO แล้ว องค์กรที่ได้รับอนุญาตจากบริการนี้จะไม่รองรับการเข้าสู่ระบบ SSO อีกต่อไป ลิงก์การเข้าสู่ระบบจะไม่ถูกต้อง และจะได้รับอีเมลเพื่อหยุดใช้การเข้าสู่ระบบ SSO',
  'app.profile.sso.list.deleteSuccess': 'ลบสำเร็จ',
  'app.profile.sso.list.confirm.modify.title': 'ยืนยันการอนุญาตบริการ SSO?',
  'app.profile.sso.list.confirm.modify.content.add':
    'องค์กรที่ได้รับอนุญาตใหม่จะได้รับอีเมลที่ต้องการการเข้าสู่ระบบ SSO',
  'app.profile.sso.list.confirm.modify.content.remove':
    'องค์กรที่ได้รับอนุญาตจะได้รับอีเมลที่ต้องการการเข้าสู่ระบบ SSO',
  'app.profile.sso.option.step1': 'การกำหนดค่า IdP',
  'app.profile.sso.option.step2': 'การส่งคืนแหล่งข้อมูล',
  'app.profile.sso.option.step3': 'อนุญาตองค์กร',
  'app.profile.sso.option.step4': 'การตรวจสอบ',
  'app.profile.sso.option.continue': 'ดำเนินการต่อ',
  'app.profile.sso.option.prev': 'ก่อนหน้า',
  'app.profile.sso.option.back': 'กลับ',
  'app.profile.sso.option.submit': 'ส่ง',
  'app.profile.sso.option.save': 'บันทึกและตรวจสอบ',
  'app.profile.sso.step1.title': 'กำหนดค่า Engagelab ใน IdP',
  'app.profile.sso.step1.description':
    'การเข้าสู่ระบบเดียว (SSO) คุณต้องเพิ่ม Engagelab เป็นแอปพลิเคชันในผู้ให้บริการตัวตน (IdP) ก่อน โปรดติดต่อผู้ดูแล IdP ขององค์กรของคุณเพื่อเพิ่มการกำหนดค่าแอปพลิเคชันภายใต้บัญชีของคุณ',
  'app.profile.sso.step1.serviceType': 'ประเภทบริการ SSO',
  'app.profile.sso.step1.guideText':
    'คุณสามารถใช้โทเค็นต่อไปนี้เพื่อทำงานร่วมกับผู้ดูแล IdP ขององค์กรของคุณ:',
  'app.profile.sso.step1.copy': 'คัดลอก',
  'app.profile.sso.step1.confirmTip':
    'ฉันยืนยันว่าข้อมูลแอปพลิเคชัน Engagelab ได้รับการอัปเดตใน IdP ของคุณแล้ว',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  'app.profile.sso.step2.title': 'ป้อนข้อมูลการส่งคืน IdP',
  'app.profile.sso.step2.description':
    'ตอนนี้คุณได้ตั้งค่าแอปพลิเคชัน Engagelab ในผู้ให้บริการตัวตนของคุณและมีข้อมูลที่จำเป็นแล้ว โปรดป้อนข้อมูลต่อไปนี้จากแอปพลิเคชัน IdP ที่นี่',
  'app.profile.sso.step2.serviceName': 'ชื่อบริการ SSO',
  'app.profile.sso.step2.serviceNamePlaceholder':
    'โปรดป้อนชื่อที่อธิบายบริการ SSO เพื่อการแยกแยะที่ง่ายในรายการบริการ',
  'app.profile.sso.step2.certificate': 'ใบรับรอง x509',
  'app.profile.sso.step2.certificatePlaceholder': 'โปรดคัดลอกเนื้อหาใบรับรอง base64 ที่นี่',
  'app.profile.sso.step2.loginUrl': 'URL การเข้าสู่ระบบ IdP',
  'app.profile.sso.step2.loginUrlPlaceholder': 'โปรดป้อน URL การเข้าสู่ระบบของผู้ให้บริการตัวตน',
  'app.profile.sso.step2.logoutUrl': 'URL การออกจากระบบ IdP',
  'app.profile.sso.step2.logoutUrlPlaceholder': 'โปรดป้อน URL การออกจากระบบของผู้ให้บริการตัวตน',
  'app.profile.sso.step3.title': 'อนุญาต IdP ให้กับองค์กร',
  'app.profile.sso.step3.description':
    'โปรดอนุญาตบริการ SSO นี้ให้กับองค์กรที่คุณได้สร้าง สมาชิกขององค์กรสามารถเข้าสู่ระบบ Engagelab โดยใช้ผู้ให้บริการตัวตน (IdP) ที่กำหนดค่า',
  'app.profile.sso.step3.selectOrg': 'เลือกองค์กร',
  'app.profile.sso.step3.contactBusiness': 'ติดต่อธุรกิจ',
  'app.profile.sso.step3.noBenefitTip': 'องค์กรปัจจุบันไม่มีสิทธิประโยชน์และไม่สามารถใช้งานได้',
  'app.profile.sso.step3.saveConfirm.title':
    'หลังจากกำหนดค่าบริการ SSO สำหรับองค์กรแล้ว สมาชิกขององค์กรต้องใช้การเข้าสู่ระบบ SSO เพื่อเข้าถึงองค์กร',
  'app.profile.sso.step3.saveConfirm.content':
    'หลังจากบันทึกแล้ว สมาชิกขององค์กรทั้งหมดจะถูกออกจากระบบและจะได้รับอีเมลที่ต้องการการเข้าสู่ระบบ SSO',
  'app.profile.sso.step3.canAuthorize': 'สามารถอนุญาตได้',
  'app.profile.sso.step3.numLimit.title': 'ถูกจำกัด',
  'app.profile.sso.step3.numLimit.tip': 'เกินขีดจำกัดโปรโตคอล SSO',
  'app.profile.sso.step3.numLimit.text': 'เกินขีดจำกัดโปรโตคอล SSO ไม่สามารถใช้งานได้',
  'app.profile.sso.step3.noBenefit.title': 'ไม่มีสิทธิ์',
  'app.profile.sso.step3.noBenefit.text': 'องค์กรปัจจุบันไม่มีสิทธิประโยชน์และไม่สามารถใช้งานได้',
  'app.profile.sso.step3.column.orgId': 'รหัสองค์กร',
  'app.profile.sso.step3.column.orgName': 'ชื่อองค์กร',
  'app.profile.sso.step3.column.memberNum': 'จำนวนสมาชิก',
  'app.profile.sso.step3.column.authStatus': 'สถานะการอนุญาต',
  'app.profile.sso.step3.column.timeZone': 'เขตเวลา',
  'app.profile.sso.step3.column.createTime': 'เวลาสร้าง',
  'app.profile.sso.step4.title': 'ตรวจสอบบริการ SSO',
  'app.profile.sso.step4.description':
    'ตอนนี้คุณได้เสร็จสิ้นการกำหนดค่า SSO ทั้งหมดแล้ว โปรดยืนยันในที่สุดว่าผู้ใช้สามารถเข้าสู่ระบบ Engagelab ได้สำเร็จโดยใช้ SSO',
  'app.profile.sso.step4.loginUrl': 'URL การเข้าสู่ระบบ SSO',
  'app.profile.sso.step4.tip': 'เคล็ดลับ',
  'app.profile.sso.step4.tipContent':
    'บัญชีที่เข้าสู่ระบบผ่านลิงก์นี้จะได้รับบทบาท Default โดยอัตโนมัติหากไม่มีบทบาทใดๆ ในองค์กร คุณสามารถแก้ไขบทบาทของพวกเขาหลังจากสมาชิกเข้าร่วม',
  'app.profile.sso.step4.notice': 'โปรดทราบ',
  'app.profile.sso.step4.noticeContent':
    'บัญชีที่เข้าสู่ระบบผ่านลิงก์นี้จะได้รับบทบาท Default โดยอัตโนมัติหากไม่มีบทบาทใดๆ ในองค์กร คุณสามารถแก้ไขบทบาทของพวกเขาหลังจากสมาชิกเข้าร่วม',
  'app.profile.sso.step4.needHelp': 'ยังต้องการความช่วยเหลือ',
  'app.profile.sso.step4.helpContent':
    'ไม่สามารถเข้าสู่ระบบได้สำเร็จ? โปรดอ้างอิงเอกสารสำหรับการตรวจสอบ',
  'app.profile.sso.step4.viewDoc': 'ดูเอกสาร',
  'app.profile.sso.details.title': 'รายละเอียดบริการ SSO',
  'app.profile.sso.details.serviceDetails': 'รายละเอียดบริการ SSO',
  'app.profile.sso.details.name': 'ชื่อ',
  'app.profile.sso.details.namePlaceholder': 'โปรดป้อนชื่อ',
  'app.profile.sso.details.type': 'ประเภท',
  'app.profile.sso.details.typePlaceholder': 'โปรดป้อนประเภท',
  'app.profile.sso.details.loginLink': 'ลิงก์การเข้าสู่ระบบ SSO',
  'app.profile.sso.details.loginLinkPlaceholder': 'โปรดป้อนลิงก์การเข้าสู่ระบบ SSO',
  'app.profile.sso.details.spConfig': 'ข้อมูลการกำหนดค่า SP',
  'app.profile.sso.details.entityIdPlaceholder': 'โปรดป้อน Entity ID',
  'app.profile.sso.details.idpConfig': 'ข้อมูลการกำหนดค่า IDP',
  'app.profile.sso.details.certificatePlaceholder': 'โปรดป้อนใบรับรอง X.509',
  'app.profile.sso.details.loginUrlPlaceholder': 'โปรดป้อน Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': 'โปรดป้อน Logout URL',
  'app.profile.sso.details.urlPlaceholder': 'โปรดป้อน URL ที่ถูกต้อง',
  'app.profile.sso.details.certificateExpiry': 'ใบรับรองจะหมดอายุใน {date}',
  'app.profile.sso.details.cancel': 'ยกเลิก',
  'app.profile.sso.details.save': 'บันทึก',
  'app.profile.sso.orgSelect.title': 'อนุญาตองค์กร',
  'app.profile.sso.orgSelect.availableOrg': 'องค์กรที่ใช้ได้',
  'app.profile.sso.orgSelect.serviceExpired': 'สิทธิประโยชน์ของบริการหมดอายุ ไม่สามารถใช้งานได้',
  'app.profile.sso.orgSelect.contactBusiness': 'ติดต่อธุรกิจ',
  'app.profile.sso.orgSelect.authorizedService': 'บริการที่ได้รับอนุญาต',
  'app.profile.sso.orgSelect.serviceNameLong':
    'ชื่อบริการ SSO ชื่อบริการ ชื่อบริการ ชื่อบริการ SSO ชื่อบริการ ชื่อบริการ ชื่อบริการ ชื่อบริการ SSO ชื่อบริการ ชื่อบริการ ชื่อบริการ SSO ชื่อบริการ ชื่อบริการ ชื่อบริการ ชื่อบริการ',
  'app.profile.sso.orgSelect.selectedOrg': 'องค์กรที่เลือก',
  'app.profile.sso.orgSelect.noSelectedOrg': 'ไม่มีองค์กรที่เลือก โปรดเลือกจากด้านซ้าย',
  'app.profile.sso.orgSelect.noAvailable': 'ไม่มีองค์กรที่ใช้ได้',
  'app.profile.sso.orgSelect.authorized': 'ได้รับอนุญาต',
  'app.profile.sso.orgSelect.cancel': 'ยกเลิก',
  'app.profile.sso.orgSelect.save': 'บันทึก',
  'app.profile.sso.orgSelect.canAuthorize': 'สามารถอนุญาตได้',
  'app.profile.sso.orgSelect.otherAuthorize': 'การอนุญาตอื่น',
  'app.profile.sso.orgSelect.noBenefit': 'ไม่มีสิทธิประโยชน์',
  'app.profile.sso.orgSelect.saveSuccess': 'บันทึกสำเร็จ',
  'app.profile.sso.list.ssoServiceName': 'ชื่อบริการ SSO',
  'app.profile.sso.list.ssoType': 'ประเภท',
  'app.profile.sso.list.ssoLoginUrl': 'ลิงก์เข้าสู่ระบบ SSO',
  'app.profile.sso.list.authOrgList': 'องค์กรที่ได้รับอนุญาต',
  'app.profile.sso.authorized.organizations': 'องค์กรที่ได้รับอนุญาต',
  'app.profile.sso.benefit.status': 'สถานะสิทธิประโยชน์',

  'app.sso.no.permission.title': 'ไม่มีสิทธิ์เข้าถึงหน้านี้',
  'app.sso.no.permission.desc': 'กรุณาติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์',
  'app.sso.no.permission.logout': 'ออกจากระบบ',
};
